import { render, staticRenderFns } from "./SatSurveysTable.vue?vue&type=template&id=5a3a74fe&scoped=true&"
import script from "./SatSurveysTable.vue?vue&type=script&lang=ts&"
export * from "./SatSurveysTable.vue?vue&type=script&lang=ts&"
import style0 from "./SatSurveysTable.vue?vue&type=style&index=0&id=5a3a74fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3a74fe",
  null
  
)

export default component.exports